import { Box } from "@mui/material"
import { Outlet } from "react-router-dom"
import { isMobile } from 'react-device-detect';
import MobileNav from "./MobileNav"
import DesktopNav from "./DesktopNav"
import { useState } from "react";

type Props = {
  children: React.ReactNode
}

export default function AppLayout({ children }: Readonly<Props>) {
  const [open, setOpen] = useState(true);
   const toggleDrawer = () => {
    setOpen(!open)
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {!isMobile && <DesktopNav open={open} toggleDrawer={toggleDrawer} />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          mt: isMobile ? 0 : 8,
          mb: isMobile ? 8 : 0,
          width: "100%",
          ...(isMobile
            ? {}
            : {
                ml: open ? "250px" : "80px",
                maxWidth: `calc(100% - ${isMobile ? 0 : open ? "250px" : "80px"})`,
              }),
        }}
      >
        <Outlet />
        {children}
      </Box>

      {isMobile && <MobileNav />}
    </Box>
  )
}
